import moment from "moment";
import { Timezone } from "./timezone";
export const getFileExtension = (url) => {
  // Get the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf("/") + 1);

  // Get the file extension by getting the last part of the filename after the last '.'
  const extension = filename.substring(filename.lastIndexOf(".") + 1);

  return extension;
};

export const isObjectEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key]) {
      if (obj[key] === '{"min":0,"max":20000000}') {
      } else {
        return false;
      }
    }
  }
  return true;
};

export function formatDate(date) {
  const now = moment();
  const inputDate = moment(date);

  if (now.isSame(inputDate, "day")) {
    return "Today, " + inputDate.format("hh:mm A");
  } else if (now.subtract(1, "day").isSame(inputDate, "day")) {
    return "Yesterday, " + inputDate.format("hh:mm A");
  } else {
    return inputDate.format("DD/MM/YYYY, hh:mm A");
  }
}

export function formatPhone(countryCode, phoneNumber) {
  if (!phoneNumber) return "";
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (countryCode && numericPhoneNumber) {
    const groups = numericPhoneNumber.match(/(\d{2})(\d{3})(\d{3})(\d+)/);
    if (groups) {
      return `+${countryCode}-${groups[1]}-${groups[2]}-${groups[3]}-${groups[4]}`;
    }
  }
  return phoneNumber;
}

export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const removeNullValues = (obj) => {
  for (const key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    }
  }
  return obj;
};

export const dateString = (created_at, format = "LLL") => {
  console.log("Client TimeZone", Timezone);
  if (!created_at) return;
  return moment(created_at).tz(Timezone).format(format);
};

export const getRandomColor = (index) => {
  const color = [
    "#a9de03",
    "#52e2f8",
    "#cb04b6",
    "#da2deb",
    "#06d6bd",
    "#bb3913",
    "#2026c8",
    "#9d8252",
    "#8b121a",
    "#0d7047",
    "#04acc2",
    "#852472",
    "#ea2c43",
    "#53d965",
    "#de5867",
    "#ac1c11",
    "#0a4c9e",
    "#170232",
    "#f04b3f",
    "#5f0044",
  ];
  // Generate random values for red, green, and blue components
  return color[index];

  var r = Math.floor(Math.random() * 256);
  var g = Math.floor(Math.random() * 256);
  var b = Math.floor(Math.random() * 256);

  // Convert decimal values to hexadecimal
  var hexR = r.toString(16).padStart(2, "0");
  var hexG = g.toString(16).padStart(2, "0");
  var hexB = b.toString(16).padStart(2, "0");

  // Concatenate and return the hex color code
  return "#" + hexR + hexG + hexB;
};
export const emailDomainValidation = {
  validator: (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(\.*)$/;

    if (!emailRegex.test(value)) {
      return Promise.resolve();
    }

    const allowDomain = [
      "gmail.com",
      "outlook.com",
      "yahoo.com",
      "iamdojo.com",
      "dojo.com",
      "company.co.uk",
      "hotmail.com",
      "company.us",
      "gov.us",
      "yopmail.com",
    ];

    // Split the email to extract the domain
    const emailParts = value.split("@");
    if (emailParts.length !== 2) {
      return Promise.resolve();
    }
    const domain = emailParts[1];
    if (!allowDomain.includes(domain)) {
      return Promise.reject(
        new Error("Please enter a valid email domain address.")
      );
    }

    return Promise.resolve();
  },
};
export const noExtraSpacesValidation = {
  validator: (_, value) => {
    if (!value) {
      return Promise.resolve(); // Skip validation for empty values (handled by required rule)
    }

    // Regular expressions for validation
    const noExtraSpacesRegex = /^[^\s](.*[^\s])?$/; // No leading or trailing spaces
    const noMultipleSpacesWithinRegex = /^[^\s]+(\s[^\s]+)*$/; // No multiple spaces between words

    // Check for leading/trailing spaces
    if (!noExtraSpacesRegex.test(value)) {
      return Promise.reject(
        new Error("Please remove leading or trailing spaces.")
      );
    }

    // Check for multiple spaces between words
    if (!noMultipleSpacesWithinRegex.test(value)) {
      return Promise.reject(
        new Error("Please remove extra spaces between words.")
      );
    }

    return Promise.resolve(); // Validation passed
  },
};



export const formatAvailability  = (values) => {

  const availability = {}
  Object.keys(values).forEach((key) => {
    if (key.endsWith("Range")) {
      const day = key.replace("Range", "");
      const timeRange = values[key];
      if (timeRange) {
        const [startTime, endTime] = timeRange;
        const start = moment(startTime, "HH:mm");
        const end = moment(endTime, "HH:mm");
        const slots = [];

        // let currentTime = start.clone();
        // while (currentTime.isBefore(end) || currentTime.isSame(end)) {
        //   const nextTime = currentTime.clone().add(30, "minutes");
        //   if (nextTime.isAfter(end) || nextTime.isSame(end)) break;
        //   slots.push(`${currentTime.format("HH:mm")} - ${nextTime.format("HH:mm")}`);
        //   currentTime = nextTime;
        // }

        let currentTime = start.clone();
        while (currentTime.isBefore(end)) {
          const nextTime = currentTime.clone().add(30, "minutes");
          if (nextTime.isAfter(end)) {
            // Add the last slot if it ends exactly at the end time
            slots.push(`${currentTime.format("HH:mm")} - ${end.format("HH:mm")}`);
            break;
          }
          slots.push(`${currentTime.format("HH:mm")} - ${nextTime.format("HH:mm")}`);
          currentTime = nextTime;
        }

        if (slots.length > 0) {
          const lastSlot = slots[slots.length - 1];
          const [lastStart, lastEnd] = lastSlot.split(" - ");
          if (lastStart === lastEnd) {
            slots.pop(); // Remove invalid slot
          }
        }


        availability[day] = {
          startTime: moment(startTime).format("HH:mm"),
          endTime: moment(endTime).format("HH:mm"),
          isOpen: true,
          slots : slots
        };
      } else {
       availability[day] = {
          startTime: null,
          endTime: null,
          isOpen: false,
          slots : []
        };
      }
    }
  });

  return availability;
}
